import * as Yup from "yup";

export const eventSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome do evento muito curto")
        .required("O nome do evento é obrigatório"),
    startDate: Yup.date()
        .required("Data de início obrigatória"),
    endDate: Yup.date()
        .required("Data de fim obrigatória")
        .test(
            "is-greater",
            "A data de fim não pode ser anterior à data de início",
            function (value) {
                const { startDate } = this.parent;
                if (!startDate || !value) return true;
                return new Date(value) >= new Date(startDate);
            }
        ),
    type: Yup.string()
        .oneOf(["evaluation", "test", "extra"])
        .default("evaluation"),
    badgeImageUrl: Yup.string().nullable().when("type", {
        is: "extra",
        then: () => Yup.string().url("URL inválida").nullable(),
        otherwise: () => Yup.string().nullable()
    }),
    testType: Yup.string().when("type", {
        is: "test",
        then: () => Yup.string().oneOf(["fixed_time", "fixed_distance"]).required("O tipo de teste é obrigatório"),
        otherwise: () => Yup.string().nullable()
    }),
    fixedTime: Yup.number()
        .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
        .nullable()
        .when("testType", {
            is: "fixed_time",
            then: () => Yup.number().min(1, "O tempo deve ser maior que 0").required("O tempo fixo é obrigatório"),
            otherwise: () => Yup.number().nullable()
        }),
    fixedDistance: Yup.number()
        .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
        .nullable()
        .when("testType", {
            is: "fixed_distance",
            then: () => Yup.number().min(1, "A distância deve ser maior que 0").required("A distância fixa é obrigatória"),
            otherwise: () => Yup.number().nullable()
        }),
    rewardXp: Yup.number()
        .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
        .nullable()
        .when("type", {
            is: "extra",
            then: () => Yup.number().min(0, "A recompensa em pontos (XP) não pode ser negativa").nullable(),
            otherwise: () => Yup.number().nullable()
        }),
    description: Yup.string().nullable(),
});
